import { useQuery } from '@tanstack/react-query';
import { useApi } from '@adiox/ui';
import { useStream } from '../stream/stream';
import { pointSize } from './levels';
import { useActiveLogin } from './useTrading';

/**
 * Account money per 1.0 of price movement for one lot of `symbol`, from the server's profit preview (the terminal never
 * works out conversions itself). Profit is linear in volume, so one probe per symbol serves every volume. Null until known.
 */
export function useMoneyPerLot(symbol: string | null, digits: number): number | null {
  const api = useApi();
  const login = useActiveLogin();
  const open = useStream((s) => (symbol ? s.quotes[symbol]?.ask : undefined));
  const probe = pointSize(digits) * 1_000;
  return (
    useQuery({
      queryKey: ['money-per-lot', login, symbol],
      enabled: login !== undefined && symbol !== null && open !== undefined,
      staleTime: 60_000,
      queryFn: async () => {
        const { data } = await api.GET('/api/v1/accounts/{login}/profit-preview', {
          params: {
            path: { login: login! },
            query: { symbol: symbol!, side: 'Buy', volume: 1, open: open!, close: open! + probe },
          },
        });
        return data ? Math.abs(data.profit) / probe : null;
      },
    }).data ?? null
  );
}
